import { useState, useEffect, useCallback } from "react";
import { useUser } from "../context/userContext";
import { getCommissionProgressByAgentId } from "../api/commissionProgressApi";

/**
 * Small hook to fetch sales.
 * Replace fetch URL with your API helper if available.
 */
export default function UseFetchAgentCommission(shouldFetch = true) {
    const { user } = useUser();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(shouldFetch);
    const [error, setError] = useState(null);

    const fetchAgentCommission = useCallback(async (signal) => {
        if (!shouldFetch) {
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await getCommissionProgressByAgentId(user.userId, { signal });
            const salesCommissionArray = Array.isArray(response)
                ? response
                : (
                    response && Array.isArray(response.data)
                        ? response.data
                        : []
                );
            setData(salesCommissionArray);
        }
        catch (err) {
            if (err.name !== "AbortError") {
                setError(err);
            }
        }
        finally {
            setLoading(false);
        }
    }, [shouldFetch, user.userId]);

    // run whenever agentArray changes
    useEffect(() => {
        if (!shouldFetch) {
            setLoading(false);
            return;
        }
        const ac = new AbortController();
        fetchAgentCommission(ac.signal);
        return () => ac.abort();
    }, [fetchAgentCommission, shouldFetch]);

    const refresh = useCallback(() => {
        if (shouldFetch) {
            fetchAgentCommission();
        }
    }, [fetchAgentCommission, shouldFetch]);

    return { data, loading, error, refresh };
}